<template>
  <v-dialog v-model="show" max-width="700px" persistent v-if="localUser">
    <v-card>
      <v-card-title>
        <div>
          <h3>
            {{ user ? $t("Generic.Edit") : $t("Generic.Create") }}
            {{
              localUser.name == "" ? $t("Manage_Users.User") : localUser.name
            }}
          </h3>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click.native="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-3"></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" v-model="valid">
                <v-text-field
                  :label="$t('Generic.Name')"
                  v-model="localUser.name"
                  :rules="[v => !!v || $t('Rules.Name_required')]"
                ></v-text-field>

                <v-text-field
                  :label="$t('Generic.Mail')"
                  v-model="localUser.mail"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>

                <v-select
                  v-model="localUser.roles"
                  :items="roles"
                  :label="$t('Generic.Roles')"
                  item-text="name"
                  deletable-chips
                  small-chips
                  chips
                  multiple
                  return-object
                ></v-select>
              </v-form>
              <user-rights-table :userRights="userRights"></user-rights-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text v-on:click="show = false">{{ $t("Generic.Cancel") }}</v-btn>
        <v-btn
          text
          :color="user ? 'blue' : 'green'"
          v-on:click="validateUser"
          :disabled="!valid"
          >{{
            user
              ? $t("Generic.Save")
              : $t("Generic.Create") + " " + localUser.name
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ConstantsValues from "../../constants/constants";
import UserRightsTable from "./UserRightsTable.vue";
import UserService from "../../services/UserService";

export default {
  data() {
    return {
      localUser: undefined,
      userRights: [],
      initialRights: [],
      isLoadingRights: true,
      valid: false,
      roles: [ConstantsValues.Roles.Admin],
      rules: {
        required: value => !!value || this.$i18n.t("Rules.Mail_required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("Rules.Mail_invalid");
        }
      }
    };
  },
  props: {
    value: Boolean,
    user: Object
  },
  methods: {
    validateUser() {
      if (this.$refs.form.validate()) {
        const userRequest = {
          user: this.localUser,
          rights: this.getUserRightsChanges(),
          roles: this.getUserRolesChanges()
        };

        this.$emit(
          this.user ? "validate-edit-user" : "validate-create-user",
          userRequest
        );
      }
    },
    getUserRightsChanges() {
      const rightChanges = {
        added: [],
        modified: [],
        deleted: []
      };

      for (const ur of this.userRights) {
        const initialUR = this.initialRights.find(
          iur => iur.siteId === ur.siteId
        );

        if (!initialUR) {
          rightChanges.added.push(ur);
        } else if (initialUR.rightLevel !== ur.rightLevel) {
          rightChanges.modified.push(ur);
        }
      }

      for (const initialUR of this.initialRights) {
        const ur = this.userRights.find(iur => iur.siteId === initialUR.siteId);

        if (!ur) {
          rightChanges.deleted.push(initialUR);
        }
      }

      return rightChanges;
    },
    getUserRolesChanges() {
      const roleChanges = {
        added: [],
        modified: [], //Always empty for now
        deleted: []
      };

      for (const role of this.localUser.roles) {
        const initialRole = this.user?.roles.find(iur => iur.id === role.id);

        if (!initialRole) {
          roleChanges.added.push(role);
        } else {
          roleChanges.deleted.push(initialRole);
        }
      }

      for (const initialRole of this.user?.roles) {
        const role = this.localUser.roles.find(
          iur => iur.id === initialRole.id
        );

        if (!role) {
          roleChanges.deleted.push(initialRole);
        }
      }

      return roleChanges;
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (this.user) {
          this.localUser = JSON.parse(JSON.stringify(this.user));

          UserService.GetUserAccesses(this.user.id)
            .then(r => {
              this.userRights = r.data;
              this.initialRights = JSON.parse(JSON.stringify(r.data));
            })
            .catch(e => console.log(e))
            .finally(() => (this.isLoadingRights = false));
        } else {
          this.localUser = {
            name: "",
            mail: "",
            active: true,
            roles: [],
            rights: []
          };

          this.userRights = [];
          this.isLoadingRights = false;
        }
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  components: {
    UserRightsTable
  }
};
</script>
